import React from 'react'
import PropTypes from 'prop-types'
import { Loader } from 'src/designSystem'
import { usePatientHistoryValues } from './usePatientHistoryValues'
import ParticipantHistoryScoreGraph from './ParticipantHistoryScoreGraph'

function RenderParticipantHistoryScoreGraph({ uid, type, programStartDate, height }) {
  const { patientHistory, loading, error } = usePatientHistoryValues(uid, type)

  if (loading) {
    return <Loader size="large" />
  }

  if (error || !patientHistory) {
    return null
  }

  return (
    <ParticipantHistoryScoreGraph
      data={{ patientHistory }}
      height={height}
      programStartDate={programStartDate}
      type={type}
    />
  )
}

RenderParticipantHistoryScoreGraph.propTypes = {
  uid: PropTypes.string.isRequired,
  type: PropTypes.oneOf(['GAD7', 'PHQ9']).isRequired,
  programStartDate: PropTypes.string,
  height: PropTypes.number,
}

export default RenderParticipantHistoryScoreGraph
